/**
 * @fileoverview Phone input English (EN) bundle — AUTHORED here, the degrade path an unwired tree renders,
 * and the key set `es.js` must match leaf for leaf.
 * @package @puffin-core/phone-ui
 *
 * Born JSDOC-PROP-CONTRACT-001 PACKAGE-I18N-SEAT U3 (2026-10-23), namespace #51: until then the package
 * carried NO catalog of its own — the country picker's names, its search box and its empty state were
 * English literals in `CountryDropdown.jsx`, so every phone field on a Spanish form (the signup form, the
 * storefront checkout, every admin edit drawer) carried an English picker. Every value is the English it
 * rendered before the move, byte for byte.
 *
 * The blur-validation message (`invalidPhone`) moved here from page-shell's `shell` namespace
 * (`dataErrors.phoneInvalid`, byte for byte): a MARKETING instance registers `phoneUi` but not `shell`, so
 * pos-web's public `/demo` form showed it in English to a Spanish visitor. The country NAMES are
 * `@puffin-core/phone`'s data.
 *
 * Placeholders are `{{double}}` braces — the same syntax i18next interpolates when the namespace is
 * registered, so both resolution paths read one template.
 *
 * @module @puffin-core/phone-ui/strings/en
 */

export const PHONE_UI_EN = Object.freeze({
  // The country picker (`components/CountryDropdown.jsx`)
  countryCodeLabel: 'Country code: +{{callingCode}}',
  selectCountry: 'Select country',
  searchCountriesPlaceholder: 'Search countries...',
  searchCountries: 'Search countries',
  noCountriesFound: 'No countries found',
  // The field's blur validation (`hooks/usePhoneInput.js`)
  invalidPhone: 'Please enter a valid phone number',
});

export default PHONE_UI_EN;
